import React, { useState, useEffect,  } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components'; // Import ThemeProvider
import Header from './components/Header.js';
import Home from './components/Home.js';
import GlobalStyle from './GlobalStyle.js';
import Footer from './components/Footer.js';
import { theme } from './Theme.js'; // Import your theme object
import styled from 'styled-components';
import GlobalPopup from './GlobalPopup.js';
import ScrollToTop from './ScrollToTop.js'
import BackToTop from './components/BackToTop.js';
import ChatNow from './components/ChatNow.js';
import Chatbot from './components/Chatbot.js';
import PrivacyPolicy from './components/PrivacyPolicy.js';
import TermsAndConditions from './components/TermsAndConditions.js';
import NotFound404 from './components/NotFound404.js';
import OfflineWrapper from "./OfflineWrapper";
import About from './components/About.js';
import TallyCalculas from './components/TallyCalculas.js';
import GovtSkills from './components/GovtSkills.js';
import Certifications from './components/Certifications.js';
const MainContent = styled.main`
  margin-top: 10px; /* Adjust this value to match your header's height */
  // padding: 1rem;
  /* Additional styling as needed */
`;
function App() {
    const [loading, setLoading] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('/api/products'); // Update with your actual API endpoint
        const data = await response.json();
        console.log("Fetched products:", data); // Log fetched products
        setProducts(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);
  

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <OfflineWrapper>
        <Router>
          <ScrollToTop />
          <Header onSearchClick={() => setShowSearch(true)} />
          {/* <GlobalPopup /> */}
          <MainContent>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/termsconditions" element={<TermsAndConditions />} />

              <Route path="/chatbot" element={<Chatbot />} />
              <Route path="/chatnow" element={<ChatNow />} />
              <Route path="/about" element={<About />} />
              <Route path="/tallycalculas" element={<TallyCalculas />} />
              <Route path="/certifications" element={<Certifications />} />


              <Route path="*" element={<NotFound404 mode="404" homeLink="/" />} />


              {/* <Route path="/dashboard" element={< CustomerList />} />
                <Route path="/dashboard" element={< Orders />} /> */}
            </Routes>
          </MainContent>
          <Footer />
        </Router>
        <BackToTop />
        <ChatNow />
      </OfflineWrapper>
    </ThemeProvider>
  );
}
export default App;
